import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		type:'list',
		addParams:{},
		money:0,
		activityMoney:0,
		remark:'',
		detail:[],
	},
	getters: {
		
	},
	mutations: {
		set_type(state, params) {
			state.type = params;
		},
		set_addParams(state, obj) {
			state.addParams = obj;
		},
		set_money(state, params) {
			state.money = params;
		},
		set_activityMoney(state, params) {
			state.activityMoney = params;
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
		set_detail(state, obj) {
			let totalMoney = 0;
			for(let i=0;i<obj.list.length;i++){
				totalMoney = $public.jia(totalMoney,obj.list[i].planMoney)
			}
			console.log(obj)
			state.detail = obj;
			state.money = totalMoney;
		},
	},
	actions: {

	},
};
